var _path, _path2, _rect, _path3, _path4, _g, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9725)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9725)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#0A17A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3335 10.0001C17.3335 8.00008 17.3335 6.66675 17.3335 6.66675L18.6668 7.33341L20.0002 6.66675L21.3335 7.33341L22.6668 6.66675C22.6668 6.66675 22.6668 8.00008 22.6668 10.0001C22.6668 12.0001 20.0002 13.3334 20.0002 13.3334C20.0002 13.3334 17.3335 12.0001 17.3335 10.0001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_9725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 6,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3335 10.0001C17.3335 8.00008 17.3335 6.66675 17.3335 6.66675L18.6668 7.33341L20.0002 6.66675L21.3335 7.33341L22.6668 6.66675C22.6668 6.66675 22.6668 8.00008 22.6668 10.0001C22.6668 12.0001 20.0002 13.3334 20.0002 13.3334C20.0002 13.3334 17.3335 12.0001 17.3335 10.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_9725)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.3335,
    y: 12.0001,
    width: 5.33333,
    height: 1.33333,
    fill: "#9ACCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 9.33333C20.3684 9.33333 20.6668 9.03486 20.6668 8.66667C20.6668 8.29848 20.3684 8 20.0002 8C19.632 8 19.3335 8.29848 19.3335 8.66667C19.3335 9.03486 19.632 9.33333 20.0002 9.33333ZM18.6667 10.6667C19.0349 10.6667 19.3333 10.3682 19.3333 10C19.3333 9.63181 19.0349 9.33333 18.6667 9.33333C18.2985 9.33333 18 9.63181 18 10C18 10.3682 18.2985 10.6667 18.6667 10.6667ZM21.9998 9.99998C21.9998 10.3682 21.7014 10.6666 21.3332 10.6666C20.965 10.6666 20.6665 10.3682 20.6665 9.99998C20.6665 9.63179 20.965 9.33331 21.3332 9.33331C21.7014 9.33331 21.9998 9.63179 21.9998 9.99998Z",
    fill: "url(#paint0_linear_2858_9725)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.333333H-0.901086L-0.21693 0.253086L4.33333 4.15331V5.16179L-0.193746 8.39542L-0.333333 8.49513V8.66667V9.33333V9.93475L0.176666 9.616L5.42893 6.33333H6.55984L11.0821 9.56351C11.176 9.6306 11.2886 9.66667 11.404 9.66667C11.9182 9.66667 12.1548 9.02698 11.7644 8.69237L7.66667 5.18002V4.17154L12.0542 1.03762C12.2294 0.912475 12.3333 0.710428 12.3333 0.495127V0V-0.601416L11.8233 -0.282666L6.57107 3H5.44016L0.860413 -0.271244L0.773488 -0.333333H0.666667H0Z",
    fill: "#FF2E3B",
    stroke: "white",
    strokeWidth: 0.666667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.33333V6H4.66667V9.33333C4.66667 9.70152 4.96514 10 5.33333 10H6.66667C7.03486 10 7.33333 9.70152 7.33333 9.33333V6H12C12.3682 6 12.6667 5.70152 12.6667 5.33333V4C12.6667 3.63181 12.3682 3.33333 12 3.33333H7.33333V0H4.66667V3.33333H0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4H5.33333V3.33333V0H6.66667V3.33333V4H12V5.33333H6.66667V6V9.33333H5.33333V6V5.33333H0V4Z",
    fill: "#FF2E3B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2858_9725",
    x1: 18,
    y1: 8,
    x2: 18,
    y2: 10.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9725"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryAi);
export default __webpack_public_path__ + "static/media/Country=AI.0f046d1fef93325b958af3e9036ded7a.svg";
export { ForwardRef as ReactComponent };